import { useMemo } from 'react';
import * as en from '../../../locales/en-GB/data/footer.data';
import * as es from '../../../locales/es/data/footer.data';
import * as pt from '../../../locales/pt/data/footer.data';

const FOOTER_DATA = {
  'en-GB': en,
  es: es,
  pt: pt,
};

export const useMobileFooterText = (locale = 'en-GB') => {
  return useMemo(() => FOOTER_DATA[locale] || FOOTER_DATA['en-GB'], [locale]);
};

export default useMobileFooterText;
